import React, { useState, useEffect, useReducer } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { get } from "aws-amplify/api";
import dayjs from "dayjs";
import { I18n } from "aws-amplify/utils";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "./APIStatusDialog";
import SelectAllTransferList from "layouts/profile/components/SelectAllTransferList/SelectAllTransferList";
const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};
const reducer2 = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};

function EditUser({
  open,
  onClose,
  userData,
  onSave,
  profileUser,
  setProfileUser,
}) {
  const [formValues, setFormValues] = useState(userData);
  const [groupName, setGroupName] = useState(""); // Original group name from API
  const [groupNameSel, setGroupNameSel] = useState(""); // State to store selected group name
  const [isEditable, setIsEditable] = useState(false); // State to control read-only or editable mode for select
  const [state, dispatch] = useReducer(reducer, { audit: [], fetched: false });

  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  // Effect to get user profiles and set group name dynamically
  useEffect(() => {
    const tlmGetUserProfiles = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/userManagement/group/list",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { user_id: formValues.user_id },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        // Check if profiles exist in the response and update the state
        const profiles = response.find((item) => item.profiles)?.profiles || [];
        dispatch({ type: "DATA_RECEIVED", value: profiles });

        if (profiles.length > 0) {
          setGroupName(profiles[0]); // Set default profile
        }
      } catch (error) {
        console.error("Error fetching user profiles:", error);
      }
    };
    tlmGetUserProfiles();
  }, [formValues.user_id]);
  // Effect to get user profiles and set group name dynamically

  const tlmGetUserGroups = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: formValues.user_id },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);
      setProfileUser(
        response.profiles.map((profile) => profile.group_name) || []
      );
      if (profiles.length > 0) {
        setGroupNameSel(profiles[0]); // Set default selected profile
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };
  useEffect(() => {
    tlmGetUserGroups();
  }, [formValues.user_id]);

  // Update formValues when userData changes
  useEffect(() => {
    setFormValues(userData);
  }, [userData]);
  const handleClose = () => {
    setIsEditable(false); // Set editable to false when closing
    onClose(); // Trigger the original onClose callback
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "profile") {
      setGroupNameSel(value); // Update selected group name
    }
    setFormValues({ ...formValues, [name]: value });
  };

  // Function to assign the user to the group when saving
  const tlmPostGroupAssignment = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/group/assignment",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            group_name: groupNameSel, // Use the selected group name
            user_id: formValues.user_id,
          },
        },
      });
      return restOperation;
    } catch (error) {
      console.error("Error assigning group:", error);
    }
  };

  const handleSave = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Updating the user"),
      });

      const restOperation = await tlmPostGroupAssignment();
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("User successfully updated"),
        });
        tlmGetUserGroups();
        onSave(formValues);
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to update user"),
        });
      }

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        onClose();
        setIsEditable(false);
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to update user"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setIsEditable(false);
      }, 2000);
    }
    
  };

  const handleEdit = () => {
    setIsEditable(true); // Enable editing for select
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle>{I18n.get("Edit User")}</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name="user_email"
          label={I18n.get("User")}
          type="email"
          fullWidth
          value={formValues.user_email || ""}
          InputProps={{
            readOnly: true, // Always read-only for the User field
          }}
        />
        <TextField
          margin="dense"
          name="NAME"
          label={I18n.get("Name")}
          type="name"
          fullWidth
          value={formValues.user_name || ""}
          InputProps={{
            readOnly: true, // Always read-only for the User field
          }}
        />
        <TextField
          margin="dense"
          name="Registration Date"
          label={I18n.get("Registration Date")}
          type="date"
          fullWidth
          value={
            dayjs(formValues.tlm_app_registration_date).format("YYYY-MM-DD") ||
            ""
          } // Formatta la data
          InputProps={{
            readOnly: true, // Sempre in sola lettura
          }}
        />

        <FormControl fullWidth margin="dense">
          <InputLabel id="profile-select-label">
            {I18n.get("Profile")}
          </InputLabel>
          <Select
            labelId="profile-select-label"
            name="profile"
            value={groupNameSel}
            onChange={handleInputChange}
            label={I18n.get("Profile")}
            disabled={!isEditable} // Set select disabled based on isEditable state
          >
            {state.audit.map((profile, index) => (
              <MenuItem key={index} value={profile}>
                {profile}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {I18n.get("Cancel")}
        </Button>
        {isEditable ? (
          <Button onClick={handleSave} color="primary">
            {I18n.get("Save")}
          </Button>
        ) : (
          <Button onClick={handleEdit} color="primary">
            {I18n.get("Edit")}
          </Button>
        )}
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
}

export default EditUser;
